import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    EnrollmentService,
    EnrollmentPopupService,
    EnrollmentComponent,
    EnrollmentDetailComponent,
    EnrollmentDialogComponent,
    EnrollmentPopupComponent,
    EnrollmentDeletePopupComponent,
    EnrollmentDeleteDialogComponent,
    EnrollmentPayPopupComponent,
    EnrollmentPayDialogComponent,
    enrollmentRoute,
    enrollmentPopupRoute,
    EnrollmentResolvePagingParams,
} from './';

let ENTITY_STATES = [
    ...enrollmentRoute,
    ...enrollmentPopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        EnrollmentComponent,
        EnrollmentDetailComponent,
        EnrollmentDialogComponent,
        EnrollmentDeleteDialogComponent,
        EnrollmentPayDialogComponent,
        EnrollmentPopupComponent,
        EnrollmentDeletePopupComponent,
        EnrollmentPayPopupComponent
    ],
    entryComponents: [
        EnrollmentComponent,
        EnrollmentDialogComponent,
        EnrollmentPopupComponent,
        EnrollmentDeleteDialogComponent,
        EnrollmentPayDialogComponent,
        EnrollmentDeletePopupComponent,
        EnrollmentPayPopupComponent
    ],
    providers: [
        EnrollmentService,
        EnrollmentPopupService,
        EnrollmentResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiEnrollmentModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/enrollment/enrollment.module.ts